import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import './status.styl'
import moment from "moment/moment";
class Status extends React.Component {
    
    static propTypes = {
        className: PropTypes.string,
        startAt: PropTypes.string,
        endAt: PropTypes.string
    }

    i18n = 'app.date.status.'

    getStatus(dates) {
        const {startAt=false, endAt=false} = dates
        const now = new moment();
        let status = 'expired'

        if(startAt && now.isBefore(startAt)) {
            status = 'off'
        } else if (!endAt) {
            (status = 'live')
        }else if (endAt && now.isBefore(endAt)) {
            status = 'live'
        }

        return status;
    }

    render() {
        const {startAt, endAt, className=false} = this.props;
        const status = this.getStatus({startAt, endAt})

        return <div className={"status" + (className ? ' ' + className : '')}>
            <div className={status}><FormattedMessage id={'app.status.' + status} /></div>
        </div>
    }
}

export default Status;
